import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const socialvTemplatesGet = createAsyncThunk(
  "template/socialvTemplatesGet",
  async (__, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/template`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(response.data.template, "-----------socialvTemplates----------");
      return response.data
      
    } catch (e) {
      rejectWithValue(e?.response?.data);
    }
  }
);
